import { useContext } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';

import WorkTemplateTaskDetail from './workTemplateTaskDetail/WorkTemplateTaskDetail';
import TaskList from './TaskList';

import classes from './workTemplateTasks.module.css';

const WorkTemplateTasks = () => {
  const { task } = useContext(WorkTemplateContext);

  const displayTaskDetail = !R.isNil(task) && !R.isEmpty(task);

  return (
    <div className={classes.tasksContainer}>
      <div className={clsx(classes.pane, classes.left)}>
        <TaskList />
      </div>
      <div className={clsx(classes.pane, classes.right)}>
        {displayTaskDetail && <WorkTemplateTaskDetail />}
      </div>
    </div>
  );
};

export default WorkTemplateTasks;
